module.exports = __webpack_public_path__ + "img/多模异构.61db6b29.png";